import { Label } from "@/components/ui"
import { Props } from "./types"
import { cn } from "@/lib/utils"

const TaskFormContainer = ({
  label,
  isRequired = false,
  children,
  wrapperClassname,
  innerWrapperClassname
}: Props) => {
  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-3 items-start", wrapperClassname)}>
      {label ? <Label className="text-[12px]">{label} <span className="text-red-700 -ml-2">{isRequired ? "*" : ""}</span></Label> : <></>}
      <div className={cn(label ? "md:col-span-2" : "md:col-span-3", innerWrapperClassname)}>
        {children}
      </div>
    </div>
  )
}

export default TaskFormContainer